import React from "react";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";

const Dashboard: React.FC = () => {
  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            alignItems: "center",
            padding: 10,
          }}
        >
          {
            <div
              style={{
                position: "relative",
                background: "#cfe0ff",
                padding: "40px 20px",
                borderRadius: "10px",
                minHeight: "150px",
                overflow: "hidden",
                marginBottom: "15px",
                boxShadow: "5px 5px 10px #0000002b",
                border: "1px solid rgb(198 190 193)",
              }}
            >
              <div style={{ position: "relative", zIndex: 1 }}>
                <h4 style={{ fontWeight: 100, marginBottom: 20 }}>
                  Welcome,
                  <br />
                  {/* <span style={{ fontWeight: 900, fontSize: 35 }}>
                  {UserName}
                </span> */}
                </h4>
                <p className="m-0">
                  All you need is just a{" "}
                  <span style={{ color: "darkred", fontWeight: 600 }}>
                    Click away
                  </span>
                </p>
              </div>
            </div>
          }
          <Typography.h4
            style={{
              padding: 10,
              marginBottom: 20,
              background: "#fff",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "15px",
            }}
          >
            My Dashboard
          </Typography.h4>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default Dashboard;
